module.exports = "../../app/cells/components/subproduct_landings/contact_cell.rb";